import { alpha, SxProps, Theme } from '@mui/material/styles'
import { mobileLayoutStyles } from '../../utils/hooks/useIsMobileLayout'

export type ToolbarStyle = 'table' | 'tableDarkHeader' | 'stats'

export const getToolbarStyleColors = (style: ToolbarStyle, theme: Theme): { backgroundColor: string } => {
  switch (style) {
    case 'tableDarkHeader':
      return { backgroundColor: theme.toolbar.darkHeaderBackground }
    case 'table':
    default:
      return { backgroundColor: theme.palette.background.paper }
  }
}

export const getToolbarShellSx = (style: ToolbarStyle = 'table'): SxProps<Theme> => {
  return (theme) => {
    const { backgroundColor } = getToolbarStyleColors(style, theme)
    const { bottomSpacing, buttonHeight, minHeight } = theme.toolbar
    const borderRadius = `${theme.shape.borderRadius}px`

    return {
      alignItems: 'center',
      backgroundColor,
      border: `1px solid ${theme.palette.divider}`,
      borderRadius,
      display: 'flex',
      gap: theme.spacing(1),
      justifyContent: 'space-between',
      marginBottom: bottomSpacing,
      minHeight,
      padding: theme.spacing(2),
      ...mobileLayoutStyles(theme, {
        alignItems: 'stretch',
      }),
      '& .MuiIconButton-root': {
        backgroundColor: theme.palette.background.paper,
        border: `1px solid ${theme.palette.divider}`,
        borderRadius,
        height: 34,
        width: 34,
        ...(style === 'stats'
          ? {
              '&:hover': {
                backgroundColor: alpha(theme.palette.primary.main, 0.08),
              },
            }
          : {}),
      },
      '& .MuiInputAdornment-root .MuiIconButton-root': {
        backgroundColor: 'transparent',
        border: 'none',
        borderRadius: '50%',
        height: 'auto',
        width: 'auto',
        '&:hover': {
          backgroundColor: alpha(theme.palette.action.active, theme.palette.action.hoverOpacity),
        },
      },
      '& .MuiButton-root': {
        height: buttonHeight,
        margin: 0,
        maxHeight: buttonHeight,
        minHeight: buttonHeight,
        whiteSpace: 'nowrap',
      },
      '@keyframes toolbarIn': {
        from: {
          opacity: 0,
        },
        to: {
          opacity: 1,
        },
      },
      '& .Toolbar-content': {
        animation: `toolbarIn ${theme.transitions.duration.shorter}ms ${theme.transitions.easing.easeOut}`,
        flexWrap: 'wrap',
        ...mobileLayoutStyles(theme, {
          flexWrap: 'nowrap',
        }),
      },
    }
  }
}
